// extracted by mini-css-extract-plugin
export var deliveryRow = "_rq-a";
export var fixedHeight = "_rq-4";
export var freightLogo = "_rq-9";
export var fullWidth = "_rq-3";
export var priceColumn = "_rq-5";
export var radioSelected = "_rq-7";
export var radioUnselected = "_rq-6";
export var selectedOption = "_rq-2";
export var selectedOptionContainer = "_rq-1";
export var selection = "_rq-0";
export var tallSkeletonText = "_rq-8";